<template>
  <v-dialog
    max-width="500"
    :value="serviceNowDialog"
    @click:outside="closeServiceNowDialog"
  >
    <v-card class="py-10 px-7">
      <CloseDialogButton :close="closeServiceNowDialog" />
      <div class="align-center d-flex flex-column">

        <div
          v-if="order.service === 'DELIVERY'"
          class="background-primary-color circle d-flex justify-center mb-8"
        >
          <status-delivering />
        </div>
        <div v-else class="circle mb-8" :class="backgroundImageClass"></div>

        <div class="font-size-lg mb-12 text-center e2e-pickup-dialog">
          <span v-if="!order.serviceNow">
            Sorry, it is currently outside of the store's online ordering hours.
          </span>
          <span v-else>
            Your order will be {{ appendTextForService() }}
            {{ wait(storeInfo, "waitTime") }} minutes from the time you
            submit.
          </span>
        </div>
        <v-btn
          color="primary"
          height="48"
          width="180"
          rounded
          @click.stop="closeServiceNowDialog"
        >
          <div class="font-size-md e2e-pickupdialog-okay">ok</div>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { wait } from "@/util.js";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import StatusDelivering from "@/assets/order_status/delivering.vue";

export default {
  name: "ServiceNowDialog",
  components: { StatusDelivering, CloseDialogButton },
  computed: {
    ...mapState({
      order: (state) => state.orders.order,
      storeInfo: (state) => state.store.info
    }),
    backgroundImageClass() {
      return this.order.serviceNow ? "store-image" : "clock-image";
    }
  },
  methods: {
    appendTextForService() {
      return this.order.service === "DELIVERY"
        ? "delivered in approx."
        : "ready";
    },
    wait
  },
  props: {
    closeServiceNowDialog: Function,
    serviceNowDialog: Boolean
  }
};
</script>

<style scoped>
.circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.clock-image {
  background: var(--v-primary-base) url(~@/assets/checkout/ic-clock.svg) no-repeat center;
  background-size: 72px 72px;
}

.store-image {
  background: var(--v-primary-base) url(~@/assets/checkout/ic-store.svg) no-repeat center;
  background-size: 72px 72px;
}
</style>
